/** @jsxImportSource @emotion/react */
import { useTheme } from '@quickbit/qb-design-system';
import { useIntl } from 'react-intl';
import { Status } from 'components';
import { OnrampLayout } from './components';

export const Completed = () => {
  const { spacing } = useTheme();
  const { formatMessage } = useIntl();

  return (
    <OnrampLayout
      topChildren={
        <div>
          <Status
            heading={formatMessage({
              id: 'page.send.processing.success.title',
            })}
            subHeading={formatMessage({
              id: 'page.onramp.completed.subHeading',
            })}
            imageProps={{
              name: 'transferSuccess',
              size: spacing.xxl,
              showPlaceholder: false,
            }}
          />
        </div>
      }
    />
  );
};

export default Completed;
